"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TLSSettingsSection = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const css_1 = require("@emotion/css");
const ui_1 = require("@grafana/ui");
const TLSSettingsSection = ({ children, enabled, label, tooltipText, onToggle, readOnly, }) => {
    const { colors, spacing } = (0, ui_1.useTheme2)();
    const styles = {
        container: (0, css_1.css)({
            marginTop: 3,
        }),
        checkboxContainer: (0, css_1.css)({
            display: 'flex',
            alignItems: 'center',
        }),
        infoIcon: (0, css_1.css)({
            marginTop: -2,
            marginLeft: 5,
            color: colors.text.secondary,
        }),
        content: (0, css_1.css)({
            margin: spacing(1, 0, 2, 3),
        }),
    };
    return (react_1.default.createElement("div", { className: styles.container },
        react_1.default.createElement("div", { className: styles.checkboxContainer },
            react_1.default.createElement(ui_1.Checkbox, { value: enabled, label: label, onChange: () => onToggle(!enabled), disabled: readOnly }),
            react_1.default.createElement(ui_1.Tooltip, { placement: "top", content: tooltipText, interactive: true },
                react_1.default.createElement(ui_1.Icon, { name: "info-circle", className: styles.infoIcon, size: "sm" }))),
        enabled && children && react_1.default.createElement("div", { className: styles.content }, children)));
};
exports.TLSSettingsSection = TLSSettingsSection;
//# sourceMappingURL=TLSSettingsSection.js.map